module.exports = __webpack_public_path__ + "static/media/fundo-de-reservas-taxas.8502fc05.svg";